import React from "react";
import ToggleSwitch from "./ToggleSwitch";

export default function NotificationRow({ id, label, description, checked, onChange }) {
  return (
    <div className="flex items-start justify-between gap-4 py-2">
      <div className="min-w-0 flex-1">
        <label htmlFor={id} className="block text-sm font-medium text-text-primary">
          {label}
        </label>
        {description && (
          <p className="mt-0.5 text-xs text-text-muted leading-relaxed">
            {description}
          </p>
        )}
      </div>
      <ToggleSwitch
        id={id}
        checked={checked}
        onChange={onChange}
        ariaLabel={`${label} notifications`}
      />
    </div>
  );
}
